// extracted by mini-css-extract-plugin
export default {"button":"metamask-auth_button__W3C5+","address":"metamask-auth_address__RX+85"};